import { createStore } from "vuex";
import auth from "./modules/auth";
import parts from "./modules/parts";
import projects from "./modules/projects";
import team from "./modules/team";
import messages from "./modules/messages";
import crafts from "./modules/crafts";
import subjects from "./modules/subjects";
import craftsmen from "./modules/craftsmen";
import articles from "./modules/articles";
import repeat from "./modules/repeat";
import students from "./modules/students";
import settings from "./modules/settings";
import grads from "./modules/grads";
import mark from "./modules/mark";
import objection from "./modules/objection";
import downsub from "./modules/downsub";

export default createStore({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    parts,
    projects,
    team,
    messages,
    crafts,
    subjects,
    craftsmen,
    articles,
    repeat,
    students,
    settings,
    grads,
    mark,
    objection,
    downsub,
  },
});
